// The database views return JSON strings; write responses can be single records.
export const parseRecordArray = value => {
    const records = typeof value === 'string' ? JSON.parse(value) : value
    if (records === null || records === undefined) return []
    if (!Array.isArray(records)) throw new TypeError('Expected an array of records')
    return records.filter(record => record && typeof record === 'object' && !Array.isArray(record))
}

export const normalizeHousehold = household => ({
    ...household,
    emails: parseRecordArray(household.emails),
    phoneNumbers: parseRecordArray(household.phoneNumbers),
})

export const normalizeHouseholdResponse = data => {
    const household = Array.isArray(data) ? data[0] : data
    if (!household) return null
    if (typeof household !== 'object') throw new TypeError('Expected a household record')
    return normalizeHousehold(household)
}

export const matchesHouseholdSearch = (searchQuery, currentRow, columns) => {
    const searchText = String(searchQuery || '').toLowerCase()
    const data = currentRow.reduce((result, value, index) => {
        result[columns[index].name] = value
        return result
    }, {})
    const text = value => String(value || '').toLowerCase()
    return ['familyName', 'husbandName', 'wifeName', 'address'].some(field => text(data[field]).startsWith(searchText))
        || parseRecordArray(data.phoneNumbers).some(phone => text(phone.phoneNumber).includes(searchText))
        || parseRecordArray(data.emails).some(email => text(email.email).includes(searchText))
}
